import { useCallback } from 'react';

import { useAdvertisingPixel } from 'app/providers/AdvertisingProvider/AdvertisingProvider';

import type { IMakePixelProps } from './makePixelLink';

export const usePixel = (link?: string, props?: Partial<IMakePixelProps>) => {
  const { getPixelLink } = useAdvertisingPixel();
  const pixel = getPixelLink(link, props);
  const createPixelLink = useCallback(() => getPixelLink(link, props), [getPixelLink, link, props]);
  return {
    pixelLink: pixel,
    createPixelLink,
  };
};
